import {
	Box,
	Center,
	Heading,
	Text,
	Stack,
	useColorModeValue,
	Image,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
const Card = (props: any) => {
	const navigate = useNavigate();
	const redirect = () => {
		if (props.data.src) {
			localStorage.setItem('frameSrc', props.data.src);
			navigate('/frame');
		} else if (props.data.href) {
			localStorage.setItem('courseId', props.data.href.split('/')[2]);
			navigate('/course');
		}
	};
	return (
		<Center
			m={'0 auto'}
			p={4}
			_hover={{ transform: 'scale(1.01)' }}
			onClick={redirect}>
			<Box
				maxW={'445px'}
				w={'full'}
				// bg={useColorModeValue('#202020', 'gray.900')}
				rounded={'md'}
				overflow={'hidden'}
				cursor={'pointer'}>
				<Box>
					<Image
						src={props.data.img}
						loading='lazy'
						alt={props.data.title}
					/>
				</Box>
				<Stack
					bg={'linear-gradient(0deg, black, #1414147d)'}
					pos={'relative'}
					bottom={'40px'}
					borderBottomEndRadius={'md'}>
					<Heading
						color={useColorModeValue('#a1a1a1', 'white')}
						fontSize={'2xl'}
						fontFamily={'body'}
						p={3}>
						{props.data.title}
					</Heading>
					{props.data.desc && (
						<Text color={'#a1a1a1'} p={3} overflow={'ellipsis'}>
							{props.data.desc}
						</Text>
					)}
				</Stack>
			</Box>
		</Center>
	);
};

export default Card;
